import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

// ngUpgrade Angular core services module
// Import converted service classes in ./services here
// Add to providers array, below
// Then go back to core.services.module.ajs.ts and register the downgraded service
import { DocmanFolderRest } from './docman.service.folder';
import { DocmanFileModel } from './docman.model.file';
import { DocmanFileRest } from './docman.service.file';
import { DocmanFolderModel } from './docman.model.folder';
import { DocmanResolvesService } from '../docman-resolves.service';

@NgModule({
    imports: [
        HttpClientModule
    ],
    providers: [
        DocmanFolderRest,
        DocmanFileModel,
        DocmanFileRest,
        DocmanFolderModel,
        DocmanResolvesService
    ]
})
export class DocmanServicesModule {
    constructor() { }
}